import { IApplicationState } from '../../../../../../types/types';
import { EButtonsPanelType } from '../types';
import { getAsidePanel } from './getAsidePanel';

export const getAsidePanelButtonsPanelType = (
    state: IApplicationState
): EButtonsPanelType => {
    return getAsidePanel(state).buttonsPanelType;
};
